var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 15.1654L8.66732 13.832V11.832H12.0007C12.1775 11.832 12.347 11.7618 12.4721 11.6368C12.5971 11.5117 12.6673 11.3422 12.6673 11.1654V10.108C12.6673 9.75736 12.5247 9.41336 12.2767 9.16536L11.334 8.2227V5.83203C11.5108 5.83203 11.6804 5.76179 11.8054 5.63677C11.9304 5.51174 12.0007 5.34218 12.0007 5.16536V3.16536C12.0007 2.43003 11.4027 1.83203 10.6673 1.83203H5.33398C4.59865 1.83203 4.00065 2.43003 4.00065 3.16536V5.16536C4.00065 5.34218 4.07089 5.51174 4.19591 5.63677C4.32094 5.76179 4.49051 5.83203 4.66732 5.83203V8.2227L3.72465 9.16536C3.4752 9.41577 3.33479 9.75458 3.33398 10.108V11.1654C3.33398 11.3422 3.40422 11.5117 3.52925 11.6368C3.65427 11.7618 3.82384 11.832 4.00065 11.832H7.33398V13.832L8.00065 15.1654ZM5.33398 3.16536H10.6673V4.4987H5.33398V3.16536ZM4.66732 10.108L5.80532 8.97003C5.86735 8.90823 5.91654 8.83477 5.95006 8.75387C5.98358 8.67298 6.00078 8.58626 6.00065 8.4987V5.83203H10.0007V8.4987C10.0007 8.67603 10.0707 8.84536 10.196 8.97003L11.334 10.108V10.4987H4.66732V10.108Z",
    fill: "#AFAFAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxPin);
export default __webpack_public_path__ + "static/media/bx-pin.7723642f6ba40052cebef964901b84e8.svg";
export { ForwardRef as ReactComponent };